var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{backText: ''}}},[_vm._v("KOL 熱購")]),_vm._v(" "),_c('p',[_vm._v("check receipt message")]),_vm._v(" "),_c('p',[_vm._v("yes go to redemption page")]),_vm._v(" "),_c('p',[_vm._v("no go to fill in page")])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-628eeaaf","hasScoped":false,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Account/containers/Credit/Redemption.vue
// module id = null
// module chunks = 